import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Box, Slide, Avatar, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function InformationBubbleDialog({ open, onClose, title, messages }) {
  const [visibleCount, setVisibleCount] = useState(0);
  const messagesLength = messages?.length || 0;

  useEffect(() => {
    if (open) {
      setVisibleCount(0);
      let count = 0;
      // Start showing messages one by one with a delay
      const interval = setInterval(() => {
        count++;
        setVisibleCount(count);
        if (count >= messagesLength) {
          clearInterval(interval);
        }
      }, 700); // 0.7s delay for better reading pace

      return () => clearInterval(interval);
    }
  }, [open, messagesLength]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          bgcolor: '#f8f9fa',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #e0e0e0',
          bgcolor: '#ffffff'
        }}
      >
        {title || 'Information'}
        <IconButton onClick={onClose} sx={{ color: 'text.secondary' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2, minHeight: 300, mt: 1 }}>
        {messages?.map((msg, index) => {
          const isQ = msg.type === 'q'; // 'q' is question (user), 'a' is answer (system)
          const isVisible = index < visibleCount;

          if (!isVisible) return null;

          return (
            <Slide in={isVisible} direction={isQ ? 'left' : 'right'} key={index} mountOnEnter unmountOnExit>
              <Box sx={{ display: 'flex', flexDirection: isQ ? 'row-reverse' : 'row', alignItems: 'flex-end', gap: 1 }}>
                <Avatar sx={{ bgcolor: isQ ? 'primary.main' : 'secondary.main', width: 32, height: 32 }}>
                  {isQ ? <PersonOutlineOutlinedIcon fontSize="small" /> : <SmartToyOutlinedIcon fontSize="small" />}
                </Avatar>
                <Paper
                  elevation={1}
                  sx={{
                    p: 1.5,
                    px: 2,
                    maxWidth: '75%',
                    borderRadius: 3,
                    borderBottomRightRadius: isQ ? 4 : 24,
                    borderBottomLeftRadius: isQ ? 24 : 4,
                    bgcolor: isQ ? 'primary.main' : '#ffffff',
                    color: isQ ? '#ffffff' : 'text.primary'
                  }}
                >
                  <Typography variant="body2" sx={{ lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                    {msg.text}
                  </Typography>
                </Paper>
              </Box>
            </Slide>
          );
        })}
      </DialogContent>
    </Dialog>
  );
}
